export default "__VITE_ASSET__BRlUYFcD__"